import React from 'react';
import { SModal } from '@chargebee/sting-react';
import { cs } from '@bbkAdminUtils/css-utils';

type ConfirmationDialogProps = {
  open: boolean;
  children?: React.ReactNode;
  onClose?: (event: unknown, reason: 'backdropClick' | 'escapeKeyDown') => void;
};

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  children,
  onClose,
}) => (
  <SModal open={open}>
    <SModal.Content
      size="small"
      onEscapeKeyDown={(event) => {
        event.preventDefault();
        onClose?.(event, 'escapeKeyDown');
      }}
      onInteractOutside={(event) => {
        event.preventDefault();
        onClose?.(event, 'backdropClick');
      }}
    >
      {children}
    </SModal.Content>
  </SModal>
);

export const DialogContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => <div {...props} className={cs('tw-p-4', className)} />;
export const DialogError: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    {...props}
    className={cs('tw-break-all tw-p-4 tw-text-danger-600', className)}
  />
);
